export function getBrowserBaseLanguage() {
  if (typeof navigator === 'undefined') return 'pt';
  const lang = navigator.language || 'pt';
  return String(lang).split('-')[0]?.toLowerCase() || 'pt';
}

export function getDefaultPhonePrefixByLanguage(baseLang?: string) {
  const lang = (baseLang || getBrowserBaseLanguage()).toLowerCase();
  const prefixByLang: Record<string, string> = {
    pt: '55',
    en: '1',
    es: '34',
    fr: '33',
    de: '49',
    it: '39',
    ja: '81',
  };
  return prefixByLang[lang] ?? '55';
}

export function getDefaultCountryAlpha2ByLanguage(baseLang?: string) {
  const lang = (baseLang || getBrowserBaseLanguage()).toLowerCase();
  const countryByLang: Record<string, string> = {
    pt: 'BR',
    en: 'US',
    es: 'ES',
    fr: 'FR',
    de: 'DE',
    it: 'IT',
    ja: 'JP',
  };
  return (countryByLang[lang] ?? 'BR').toUpperCase();
}
